import _ from 'lodash';

export function GeozoneAssetDeleteModalController($scope, $uibModalInstance) {
  'ngInject';

  $scope.loading = false;
  $scope.errorFlag = false;
  $scope.errorText = '';
  $scope.confirmed = false;
  $scope.ok = function() {
    $scope.confirmed = true;
    $uibModalInstance.close($scope.confirmed);
  };
  $scope.cancel = function() {
    $uibModalInstance.dismiss('cancel');
  };
}

export default function GeozonesViewTableAssetsModalController(
  $scope,
  $q,
  $filter,
  $uibModal,
  $stateParams,
  mapService,
  $state,
  equipmentGeozoneService,
  mobileService,
  gettextCatalog,
) {
  'ngInject';

  $scope.error = {};
  $scope.error.equipment = false;
  $scope.confirmed = false;
  $scope.assets = [];
  $scope.assetsByPage = [];
  $scope.filteredAssets = [];
  $scope.search = {
    text: '',
  };
  $scope.loading = true;

  //Pagination
  $scope.current = {
    assetPage: 1,
  };
  $scope.itemsPerPage = 8;
  $scope.maxSize = 1;

  //displayUserRolesByPage() is used to set the legnth of paging needed for filteredUserRoles.
  $scope.displayAssetsByPage = function() {
    $scope.totalItems = $scope.filteredAssets.length;
    var begin = ($scope.current.assetPage - 1) * $scope.itemsPerPage;
    var end = begin + $scope.itemsPerPage;
    $scope.assetsByPage = $scope.filteredAssets.slice(begin, end);
    $scope.loading = false;
  };

  //Calls displayAssetsByPage(), everytime the the user changes the page.
  $scope.pageChanged = function() {
    $scope.displayAssetsByPage();
  };

  //applyFilter will search the assets[] for anything matching the search input.
  $scope.applyFilter = function() {
    $scope.filteredAssets = $filter('filter')($scope.assets, $scope.search.text);
    $scope.displayAssetsByPage();
  };

  //order() is used to sort the table based on it's column names, currently defaulted to the 'name' column.
  $scope.predicate = 'name';
  $scope.reverse = false;
  $scope.order = function(predicate) {
    $scope.reverse = $scope.predicate === predicate ? !$scope.reverse : true;
    $scope.predicate = predicate;
  };

  $scope.removeAssets = assetsToRemove => {
    const remove = equipmentGeozoneService.deleteEquipmentInZone(
      $stateParams.geozoneId,
      assetsToRemove,
    );

    return assetsToRemove && assetsToRemove.length > 0 ? remove : $q.resolve();
  };

  $scope.addAssets = assetsToAdd => {
    const add = equipmentGeozoneService.addEquipmentInZone($stateParams.geozoneId, assetsToAdd);

    return assetsToAdd && assetsToAdd.length > 0 ? add : $q.resolve();
  };

  $scope.isRemoveDisabled = function () { 
    return $scope.assetsByPage.filter(function(asset){ return asset.isSelected;}).length == 0
  }

  $scope.RemoveEquipmentClicked = function() {
    if ($scope.assets) {
      $scope.deleteEquipmentList = [];
      for (var i = 0; i < $scope.assets.length; i++) {
        if ($scope.assets[i].isSelected === true) {
          $scope.deleteEquipmentList.push($scope.assets[i].id);
        }
      }
      $scope.filteredAssets = $scope.assets.slice();
      $scope.displayAssetsByPage();
      $scope.errorFlag = false;
      //if the to remove asset is the only one asset left, warn the user
      if (
        $scope.deleteEquipmentList.length > 0 &&
        $scope.deleteEquipmentList.length == $scope.assets.length &&
        !$scope.confirmed
      ) {
        $scope.error.equipment = true;
        $scope.error.Msg = gettextCatalog.getString(
          'You must have at least one Asset per configuration.',
        );
        return;
      }

      updateEquipment([], $scope.deleteEquipmentList);
    }
  };

  var updateEquipment = function(added, removed) {
    $scope.errorFlag = false;
    $scope.loading = true;

    $scope
      .addAssets(added)
      .then(() => $scope.removeAssets(removed))
      .then(() => refresh())
      .catch(error => {
        var errorMsg = gettextCatalog.getString('An error occurred while updating GeoZone assets');
        if (error.data || error.status) {
          if (error.data.message) {
            errorMsg = error.data.message + ' ' + error.status.toString();
          } else {
            errorMsg += ': ' + error.status.toString();
          }
        } else {
          errorMsg += gettextCatalog.getString('. Please try again later.');
        }
        $scope.errorFlag = true;
        $scope.errorText = errorMsg;
      })
      .finally(() => ($scope.loading = false));
  };

  $scope.AddAssetsClicked = function() {
    var modalInstance = $uibModal.open({
      animation: true,
      template: require('../../../../../../components/assetpicker/asset.multi.picker.html'),
      controller: 'AssetMultiPickerController',
      resolve: {
        singleSelect: false,
        requiresSelection: true,
        maxSelection: () => 0,
        selectedAssets: () => {
          return $scope.assets.reduce((acc, asset) => {
            acc[asset.id] = asset;
            return acc;
          }, {});
        },
      },
      size: 'lg',
    });
    modalInstance.result.then(
      function(selectedAssets) {
        $scope.$on('$locationChangeStart', function(event, next, current) {
          // Here you can take the control and call your own functions:
          event.preventDefault();
        });

        updateEquipment(selectedAssets.added, selectedAssets.removed);
      },
      function(error) {},
    );
  };

  $scope.assets = [];

  var refresh = function() {
    return equipmentGeozoneService.getEquipmentInZone($stateParams.geozoneId).then(
      function(response) {
        var result = response.data;
        $scope.assets = result;

        $scope.noData = $scope.assets.length === 0;

        $scope.filteredAssets = $scope.assets.slice();
        $scope.displayAssetsByPage();
        $scope.loading = false;
      },
      function(error) {
        var errorMsg = gettextCatalog.getString(
          'An error occurred while retrieving GeoZone assets',
        );
        if (error.data || error.status) {
          if (error.data.message) {
            errorMsg = error.data.message + ' ' + error.status.toString();
          } else {
            errorMsg += ': ' + error.status.toString();
          }
        } else {
          errorMsg += gettextCatalog.getString('. Please try again later.');
        }
        $scope.onLoadErrorFlag = true;
        $scope.onLoadErrorText = errorMsg;
        $scope.loading = false;
      },
    );
  };
  refresh();
}
